import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import messages from "../../../redux/messages";
import {
  Alert,
  Button,
  ButtonGroup,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { withRouter } from "react-router";
import * as Yup from "yup";
import { Formik } from "formik";
import TipopreguntaData from "../../TipopreguntaData";
import { ReactSortable } from "react-sortablejs";
import RespuestaBreve from "./Respuestas/respuestaBreve";
import RespuestaLarga from "./Respuestas/respuestaLarga";
import SeleccionUnica from "./Respuestas/opcionMultiple";
import SelecciónMultiple from "./Respuestas/casillasVerificacion";
import RespuestaOtro from "./Respuestas/respuestaOtro";
import Desplegable from "./Respuestas/desplegable";
import EscalaLineal from "./Respuestas/escalaLineal";
import Fecha from "./Respuestas/fechaHora";
import "../../../css/plantillas.css";
import RatingIcon from "../Plantillas/Respuestas/valoracionestrellas/valoracion";
import {
  deletePlantillaCuestionariosPregunta,
  editPlantillaCuestionariosPreguntaMedicion,
  saveCambiarPlantillaCuestionariosTipoPregunta,
} from "../../../redux/climalaboral/plantillaCuestionario/action";

// const sort_lists = (key, list, inverse) =>
//   inverse
//     ? [...list].sort((b, a) =>
//         b[key] ? (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0) : 1
//       )
//     : [...list].sort((a, b) =>
//         a[key] ? (a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0) : -1
//       );

const CampoPregunta = (props) => {
  const [preguntaValue, setPreguntaValue] = useState(
    props.pregunta ? props.pregunta.pregunta : null
  );
  const schema = Yup.object().shape({
    sub_objeto: Yup.string().required("**Campo requerido"),
  });

  const [validatedMedicion, setValidatedMedicion] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [tipoPregunta, setTipoPregunta] = useState("");

  // const [opcionesT, setOpcionesT] = useState(
  //   props.pregunta.list_Plantilla_Opciones
  //     ? sort_lists("posicion", props.pregunta.list_Plantilla_Opciones)
  //     : []
  // );
  const [opcionesT, setOpcionesT] = useState(
    props.pregunta.list_Plantilla_Opciones
  );
  const [saveLoader, setSaveLoader] = useState(false);

  const measurements = useSelector((store) => store.measurements.measurements);
  const measurementsLoading = useSelector(
    (store) => store.measurements.loading
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (props.pregunta.list_tipo[0]) {
      setTipoPregunta(props.pregunta.list_tipo[0].nombre);
    } else {
      setTipoPregunta("");
    }
  }, [props.pregunta.id]);

  useEffect(() => {
    let _preguntas = props.preguntas;
    setTimeout(() => {
      _preguntas[props.index].list_Plantilla_Opciones = opcionesT;
      _preguntas[props.index].pregunta = preguntaValue;
      props.setPreguntas(_preguntas);
    }, 2000);
  }, [opcionesT, preguntaValue]);

  const cambiarTipo = (e) => {
    e.preventDefault();
    let req = {
      nuevas_opciones: [],
      opciones_eliminar: [],
      tipo_id: parseInt(e.currentTarget.value),
      pregunta_id: props.pregunta.id,
    };
    opcionesT.map((item) => {
      req.opciones_eliminar.push(item.id);
    });
    if (
      props.pregunta.list_tipo[0].nombre.toLowerCase() ===
      "Matriz/escala valoración".toLowerCase()
    ) {
      req.nuevas_opciones = [
        {
          respuesta: `Opción 1`,
          pregunta: props.pregunta.id,
          valor: 1,
          posicion: 0,
        },
        {
          respuesta: `Opción 2`,
          pregunta: props.pregunta.id,
          valor: 1,
          posicion: 1,
        },
      ];
    } else {
      req.nuevas_opciones = [
        {
          respuesta: `Opción 1`,
          pregunta: props.pregunta.id,
          valor: 1,
          posicion: 0,
        },
      ];
    }
    let _tipo = TipopreguntaData.find(
      (tp) => tp.id === parseInt(e.currentTarget.value)
    );
    setTipoPregunta(_tipo.title);
    dispatch(
      saveCambiarPlantillaCuestionariosTipoPregunta(
        req,
        opcionesT,
        setOpcionesT,
        props.preguntas,
        props.setPreguntas,
        props.index
      )
    );
  };

  const abrirModalMedicion = (id, _index) => {
    setShowModal(true);
  };

  const editMedicion = (req) => {
    req.pregunta = props.pregunta.pregunta;
    req.cuestionario = props.pregunta.cuestionario;
    req.tipo = props.pregunta.tipo;
    req.posicion = props.index;

    let _preguntas = props.preguntas;
    _preguntas[props.index].sub_objeto = req.sub_objeto;
    props.setPreguntas(_preguntas);
    dispatch(
      editPlantillaCuestionariosPreguntaMedicion(
        req,
        props.pregunta.id,
        setSaveLoader
      )
    );
    setShowModal(false);
    setValidatedMedicion(false);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(
        deletePlantillaCuestionariosPregunta(
          id,
          index,
          props.preguntas,
          props.setPreguntas
        )
      );
      window.alert("Se borro este archivo");
    }
  };

  return (
    <Form.Group
      className="contenido shadow-sm mb-5 bg-white rounded"
      style={{ border: "1px solid #ced4da" }}
    >
      <div className="estiloFondo">
        <div className="b pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-center align-items-center">
          <Button size="sm" className="btn rounded-circle buttonGrab" disabled>
            <i
              className="material-icons dragI"
              style={{ transform: "rotate(90deg)" }}
            >
              drag_indicator
            </i>
          </Button>
        </div>
      </div>
      <div className="pl-3 pr-3 pb-3 pt-3">
        <Form>
          <Row>
            <Form.Group as={Col} className="mb-3" sm="12" md="6" lg="6" xl="6">
              <Form.Label column sm="12" md="12">
                Pregunta:
              </Form.Label>
              <Form.Control
                id={`pregunta ${props.index}`}
                name="pregunta"
                className="rounded-pill"
                required
                type="text"
                // onChange={onSubmit}
                // defaultValue={props.pregunta ? props.pregunta.pregunta : null}
                value={preguntaValue}
                onChange={(e) => {
                  // e.preventDefault();
                  // setTimeout(() => {
                  setPreguntaValue(e.currentTarget.value);
                  // }, 1000);
                }}
                pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#,()]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#,()]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9@$¿?¡\-_%#,()]+$"
                placeholder="Pregunta"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite letras,numeros y los siguientes caracteres
                @$¿?¡\-_%#
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} className="mb-3" sm="12" md="6" lg="6" xl="6">
              <Form.Label column sm="12" md="12">
                Tipo de pregunta:
              </Form.Label>
              <Form.Control
                as="select"
                id={`tipo ${props.index}`}
                name="tipo"
                className="rounded-pill"
                defaultValue={props.pregunta ? props.pregunta.tipo : null}
                onChange={cambiarTipo}
              >
                {TipopreguntaData
                  ? TipopreguntaData.sort((a, b) => {
                      if (a.nombre && b.nombre) {
                        if (a.title.toLowerCase() === b.title.toLowerCase()) {
                          return 0;
                        }
                        if (a.title.toLowerCase() < b.title.toLowerCase()) {
                          return -1;
                        }
                      }
                      return 1;
                    }).map((item) => (
                      <>
                        <option key={item.id} value={item.id ? item.id : ""}>
                          {item.title ? item.title.toUpperCase() : ""}
                        </option>
                      </>
                    ))
                  : null}
              </Form.Control>
            </Form.Group>
          </Row>
        </Form>
        <div className="px-2">
          <hr />
        </div>
        {opcionesT.length === 0 ? (
          <Alert className="my-4" variant="info">
            Aún no hay preguntas registradas, comience agregando algunas.
          </Alert>
        ) : (
          <Row>
            <Form.Group as={Col} className="mb-3">
              <>
                <ReactSortable
                  tag="span"
                  list={opcionesT}
                  setList={setOpcionesT}
                  group={props.pregunta.pregunta}
                  animation={200}
                  handle=".dragI"
                  delayOnTouchOnly={true}
                  forceFallback={true}
                >
                  {opcionesT.map((item, index) => (
                    <div key={item.id}>
                      {tipoPregunta.toLowerCase() ===
                        "OPCIÓN MÚLTIPLE".toLowerCase() && (
                        <SeleccionUnica
                          valorOpcion={item}
                          index={index}
                          indexPregunta={props.index}
                          indexArreglo={props.index}
                          length={opcionesT.length}
                          loader={saveLoader}
                          setLoader={setSaveLoader}
                          opciones={opcionesT}
                          setOpciones={setOpcionesT}
                        />
                      )}
                      {tipoPregunta.toLowerCase() ===
                        "CASILLAS DE VERIFICACIÓN".toLowerCase() && (
                        <SelecciónMultiple
                          valorOpcion={item}
                          index={index}
                          indexPregunta={props.index}
                          indexArreglo={props.index}
                          length={opcionesT.length}
                          loader={saveLoader}
                          setLoader={setSaveLoader}
                          opciones={opcionesT}
                          setOpciones={setOpcionesT}
                        />
                      )}
                      {tipoPregunta.toLowerCase() ===
                        "MENU DESPLEGABLE".toLowerCase() && (
                        <Desplegable
                          valorOpcion={item}
                          index={index}
                          indexPregunta={props.index}
                          indexArreglo={props.index}
                          length={opcionesT.length}
                          loader={saveLoader}
                          setLoader={setSaveLoader}
                          opciones={opcionesT}
                          setOpciones={setOpcionesT}
                        />
                      )}
                    </div>
                  ))}
                </ReactSortable>
                {tipoPregunta.toLowerCase() ===
                  "OPCIÓN MÚLTIPLE".toLowerCase() && (
                  <RespuestaOtro
                    id={props.pregunta.id}
                    tipo="OPCIÓN MÚLTIPLE"
                    index={props.index}
                    indexArreglo={props.index}
                    nombreOpcion={opcionesT.length + 1}
                    icono={
                      <i className="material-icons">radio_button_unchecked</i>
                    }
                    save={props.save}
                    loader={saveLoader}
                    setLoader={setSaveLoader}
                    opciones={opcionesT}
                    setOpciones={setOpcionesT}
                  />
                )}
                {tipoPregunta.toLowerCase() ===
                  "CASILLAS DE VERIFICACIÓN".toLowerCase() && (
                  <RespuestaOtro
                    id={props.pregunta.id}
                    tipo="CASILLAS DE VERIFICACIÓN"
                    index={props.index}
                    indexArreglo={props.index}
                    nombreOpcion={opcionesT.length + 1}
                    icono={
                      <i className="material-icons">check_box_outline_blank</i>
                    }
                    save={props.save}
                    loader={saveLoader}
                    setLoader={setSaveLoader}
                    opciones={opcionesT}
                    setOpciones={setOpcionesT}
                  />
                )}
                {tipoPregunta.toLowerCase() ===
                  "MENU DESPLEGABLE".toLowerCase() && (
                  <RespuestaOtro
                    id={props.pregunta.id}
                    tipo="MENU DESPLEGABLE"
                    index={props.index}
                    indexArreglo={props.index}
                    nombreOpcion={opcionesT.length + 1}
                    icono={<h5>{opcionesT.length + 1}.</h5>}
                    save={props.save}
                    loader={saveLoader}
                    setLoader={setSaveLoader}
                    opciones={opcionesT}
                    setOpciones={setOpcionesT}
                  />
                )}
                {tipoPregunta.toLowerCase() ===
                  "Matriz/escala valoración".toLowerCase() && (
                  <EscalaLineal
                    valorOpcion={opcionesT[0]}
                    index={0}
                    indexPregunta={props.index}
                    indexArreglo={props.index}
                    length={opcionesT.length}
                    save={props.save}
                    opciones={opcionesT}
                    setOpciones={setOpcionesT}
                  />
                )}
                {tipoPregunta.toLowerCase() ===
                  "Matriz/escala valoración".toLowerCase() && (
                  <EscalaLineal
                    valorOpcion={opcionesT[1]}
                    index={1}
                    indexPregunta={props.index}
                    indexArreglo={props.index}
                    length={opcionesT.length}
                    save={props.save}
                    opciones={opcionesT}
                    setOpciones={setOpcionesT}
                  />
                )}
                {tipoPregunta.toLowerCase() ===
                  "CAMPO TEXTO SIMPLE".toLowerCase() && (
                  <RespuestaBreve
                    valorOpcion={opcionesT[0]}
                    index={0}
                    indexPregunta={props.index}
                    indexArreglo={props.index}
                    length={opcionesT.length}
                    save={props.save}
                    opciones={opcionesT}
                    setOpciones={setOpcionesT}
                  />
                )}
                {tipoPregunta.toLowerCase() ===
                  "CAMPO TEXTO LIBRE".toLowerCase() && (
                  <RespuestaLarga
                    valorOpcion={opcionesT[0]}
                    index={0}
                    indexPregunta={props.index}
                    indexArreglo={props.index}
                    length={opcionesT.length}
                    save={props.save}
                    opciones={opcionesT}
                    setOpciones={setOpcionesT}
                  />
                )}
                {tipoPregunta.toLowerCase() ===
                  "Valoración por estrellas".toLowerCase() && (
                  <Row className="box d-flex ml-3">
                    {[1, 2, 3, 4, 5].map((index) => {
                      return (
                        <RatingIcon
                          index={index}
                          rating={0}
                          hoverRating={0}
                          onMouseEnter={() => {}}
                          onMouseLeave={() => {}}
                          onSaveRating={() => {}}
                          save={props.save}
                        />
                      );
                    })}
                  </Row>
                )}
                {tipoPregunta.toLowerCase() === "FECHA/Hora".toLowerCase() && (
                  <Fecha />
                )}
              </>
            </Form.Group>
          </Row>
        )}
        <div className="px-2">
          <hr />
        </div>
        <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-end align-items-center">
          <Form>
            <Row className="justify-content-end align-items-center flex-nowrap">
              <Col xs="auto">
                <Row className="flex-wrap justify-content-center align-items-center">
                  <ButtonGroup className="flex-wrap justify-content-center align-items-center">
                    <ButtonGroup>
                      <OverlayTrigger
                        placement="auto"
                        overlay={<Tooltip {...props}>Editar medición</Tooltip>}
                      >
                        <Button
                          variant="link"
                          size="sm"
                          className="text-dark rounded-pill mx-1"
                          onClick={() => {
                            abrirModalMedicion(props.pregunta.id, props.index);
                          }}
                        >
                          <i className="material-icons">emoji_objects</i>
                        </Button>
                      </OverlayTrigger>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Eliminar pregunta</Tooltip>
                        }
                      >
                        <Button
                          variant="link"
                          size="sm"
                          className="text-dark rounded-pill mx-1"
                          onClick={() =>
                            onDelete(props.pregunta.id, props.index)
                          }
                        >
                          <i className="material-icons">delete_outline</i>
                        </Button>
                      </OverlayTrigger>
                    </ButtonGroup>
                  </ButtonGroup>
                </Row>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={editMedicion}
          initialValues={{
            sub_objeto: props.pregunta.sub_objeto,
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            values,
            touched,
            errors,
          }) => (
            <Form
              onSubmit={handleSubmit}
              noValidate
              validated={validatedMedicion}
            >
              <Modal.Header closeButton>
                <Modal.Title>Editar Medición</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <Form.Group as={Col} controlId="Medicion">
                    <Row className="align-items-end">
                      <Col sm={measurementsLoading ? "10" : "12"}>
                        <Form.Label className="ml-2">Medición:</Form.Label>
                        <Form.Control
                          as="select"
                          id="sub_objeto"
                          name="sub_objeto"
                          isInvalid={touched.sub_objeto && errors.sub_objeto}
                          isValid={touched.sub_objeto && !errors.sub_objeto}
                          onBlur={handleBlur("sub_objeto")}
                          onChange={handleChange}
                          value={values.sub_objeto}
                          className="rounded-pill"
                        >
                          <option key="" value="" selected disabled>
                            Seleccione una medición
                          </option>
                          {measurements
                            ? measurements
                                .sort((a, b) => {
                                  if (a.nombre && b.nombre) {
                                    if (
                                      a.nombre.toLowerCase() ===
                                      b.nombre.toLowerCase()
                                    ) {
                                      return 0;
                                    }
                                    if (
                                      a.nombre.toLowerCase() <
                                      b.nombre.toLowerCase()
                                    ) {
                                      return -1;
                                    }
                                  }
                                  return 1;
                                })
                                .map((item, index) =>
                                  props.lenght !== 0 &&
                                  props.data &&
                                  props.data.objeto === item.objeto ? (
                                    <option
                                      key={item.id}
                                      value={item.id ? item.id : ""}
                                    >
                                      {item.nombre
                                        ? item.nombre.toUpperCase()
                                        : ""}
                                    </option>
                                  ) : null
                                )
                            : null}
                        </Form.Control>
                        {touched.sub_objeto && errors.sub_objeto && (
                          <div className="px-2">
                            <small className="text-danger">
                              {errors.sub_objeto}
                            </small>
                          </div>
                        )}
                      </Col>
                      {measurementsLoading && (
                        <Col sm="2">
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                  </Form.Group>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="primary"
                  type="submit"
                >
                  Crear
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </Form.Group>
  );
};

export default withRouter(CampoPregunta);
